import React, { useState, useContext, useEffect } from 'react'
import { useRouter } from 'next/router'
import styles from '../styles/Register.module.scss'
import axios from 'axios'
import useSWR from 'swr'
import { createClient } from 'graphqurl'
import { useTranslation } from 'react-i18next'

import {
	Button,
	Card,
	Col,
	Image,
	ListGroup,
	Modal,
	Row,
} from 'react-bootstrap'

import PersonalDetails from './forms/PersonalDetails'
import WorkExperience from './forms/WorkExperience'
import Education from './forms/Education'
import AvailabilityStatus from './forms/AvailabilityStatus'

import UserContext from '../UserContext'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { lowerCase } from 'lodash'

const swrKey = `
query ($id: Int!) {
  Applicant_by_pk(id: $id) {
    name
    contact
    email
    gender
    dateOfBirth
		locationMrt
    nationality
    workPass
    whatsapp
    educationLevel
    education
    isEmployed
    unemployedDuration
    isStartWorkNow
    # password
    avatar
    cvName
    cv
		locationCity
		nric
  }

  ApplicantExperience(where: {
    applicantId: {_eq: $id}
    isDeleted: {_eq: false}
  }) {
    id
    jobTitle
    companyName
    occupation
    startDate
    endDate
    description
  }

  ApplicantEducation(where: {
    applicantId: {_eq: $id}
    isRemoved: {_eq: false}
  }) {
    id
    schoolName
    educationOther
    fieldOfStudy
    startYear endYear
    grade
    description
    Enum_EducationLevel { display}
  }
}
`

export default function ProfileSteps({ isNewProfile, token }): JSX.Element {
	const { t } = useTranslation()
	const router = useRouter()
	const source = router.query.source
	const locale = router?.locale?.toLocaleUpperCase()
	const [currentStep, setCurrentStep] = useState(1)

	// Columns(Applicant)
	const [inputs, setInputs] = useState({
		name: '',
		email: '',
		gender: '',
		dateOfBirth: '',
		locationMrt: '',
		nationality: '',
		workPass: '',
		whatsapp: '',
		nric: '',
		// dropdown
		educationLevel: '',
		// text field
		education: '',
		// languageSkills: '',
		isEmployed: false,
		unemployedDuration: '',
		isStartWorkNow: false,
		password: '',
		// update
		avatar: '', // for <Image src />
		cvName: '',
		cv: '',
		broadcastStartDate: '',
		broadcastEndDate: '',
		locationCity: null,
	})
	const [confirmPw, setConfirmPw] = useState('')

	// ApplicantExperience
	const [experiences, setExperiences] = useState([])
	const [experienceIds, setExperienceIds] = useState([]) // Determine which ApplicantExperience(s) are removed

	const [educations, setEducations] = useState([])
	const [educationIds, setEducationIds] = useState([])
	const [isMyinfoSuccess, setIsMyinfoSuccess] = useState(false)
	const [isMyinfoFail, setIsMyinfoFail] = useState(false)
	// for <Button /> state
	const [boolean, setBoolean] = useState({
		gender: '',
		isSingaporean: '',
		currentlyEmployed: '',
		startWorkImmediately: '',
		broadcastToEmployers: '',
		isLocale: '',
	})

	const [imgPreview, setImgPreview] = useState('')

	const [imgData, setImgData] = useState<File | undefined>(undefined)
	const [cvData, setCVData] = useState<File | undefined>(undefined)

	const { user } = useContext(UserContext)

	const fetcher = async (url, hasuraQuery): Promise<any> => {
		const res = await axios.get(url)

		if (res.status === 200) {
			// '/update-profile'
			if (isNewProfile === false) {
				const token = window.localStorage.getItem('token')
				try {
					const client = createClient({
						endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
						headers: { authorization: token !== null ? `Bearer ${token}` : '' },
					})
					const hasuraRes = await client.query({
						query: hasuraQuery,
						variables: { id: user.id },
					})
					const { data } = hasuraRes
					const applicantData = data.Applicant_by_pk
					const handleCVTextInput = (): any => {
						if (applicantData.cv !== null && applicantData.cv !== '') {
							return applicantData.cvName !== null &&
                applicantData.cvName !== ''
								? applicantData.cvName
								: '1 file selected'
						}
						return 'No file selected'
					}
					applicantData.cvName = handleCVTextInput()
					applicantData.locationMrt =
            applicantData.locationMrt === null ||
            applicantData.locationMrt === 'null'
            	? null
            	: applicantData.locationMrt
					applicantData.locationCity =
            applicantData.locationCity === null ||
            applicantData.locationCity === 'null'
            	? null
            	: applicantData.locationCity
					applicantData.workPass =
            applicantData.workPass === null || applicantData.workPass === 'null'
            	? null
            	: applicantData.workPass
					applicantData.unemployedDuration =
            applicantData.unemployedDuration === null
            	? ''
            	: applicantData.unemployedDuration
					setInputs(applicantData)
					setExperiences(data.ApplicantExperience)
					setEducations(data.ApplicantEducation)
					setBoolean({
						gender: applicantData.gender === 'MALE' ? 'male':applicantData.gender === 'FEMALE' ? 'female' : '',
						isSingaporean:
              applicantData.nationality === 'SG' ? 'true' : 'false',
						currentlyEmployed:
              applicantData.isEmployed === true ? 'true' : 'false',
						startWorkImmediately:
              applicantData.isStartWorkNow === true ? 'true' : 'false',
						broadcastToEmployers:
              applicantData.broadcastStartDate !== null ? 'true' : 'false',
						isLocale: applicantData.nationality === 'SG' ? 'true' : 'false',
					})
					// setExperiences()
					// const mergedObject = {
					//   ...res.data,
					//   ...data
					// }
					// return mergedObject
				} catch (err) {
					// console.error(err)
				}
			}
			if (source === 'broadcast') {
				setBoolean({ ...boolean, broadcastToEmployers: 'true' })
				setInputs({
					...inputs,
					broadcastStartDate: moment().format(),
					broadcastEndDate: moment().add(1, 'years').format(),
				})
			}
			// else {
			//   // Only returning data for selects
			//   return res.data
			// }
			// Regardless of the "source", we only need the datas for select
			return res.data
		}
	}

	const { data, error, isValidating } = useSWR(
		[process.env.NEXT_PUBLIC_FETCH_OPTIONS as string, swrKey],
		fetcher,
		{ revalidateOnFocus: false }
	)
	// if (error !== undefined) return <div>Failed to load</div>
	// if (data === undefined) return <div>Loading...</div>

	useEffect(() => {
		if (window !== undefined) {
			const isUploadResume = window.location.search.split('=')[1]
			if (isUploadResume === 'true') setCurrentStep(2)
		}
	}, [])

	useEffect(() => {
		const fetchProfile = async () => {
			await axios
				.get(`/api/singpass-auth/myinfo?token=${router.query.token}`)
				.then((response) => {
					const personData = response.data?.personData ?? null
					if (personData !== null) {
						setInputs({
							...inputs,
							nric: personData.uinfin.value,
							email: personData.email?.value ?? '',
							name: personData.name.value,
							gender: personData.sex.desc,
							dateOfBirth: personData.dob.value,
							nationality: personData.nationality.code,
							whatsapp: `${personData.mobileno.prefix.value ?? ''}${
								personData.mobileno.areacode.value ?? ''
							}${personData.mobileno.nbr.value ?? ''}`,
						})
						setBoolean({
							...boolean,
							gender: lowerCase(personData.sex.desc ?? ''),
							isLocale:
                personData.nationality.code === locale ? 'true' : 'false',
						})
						setIsMyinfoSuccess(true)
					}
				})
				.catch(() => {
					setIsMyinfoFail(true)
				})
		}
		if (token && !isValidating) fetchProfile()
	}, [token, isValidating])

	if (error !== undefined) return <div>Failed to load</div>
	if (data === undefined) return <div>Loading...</div>

	const filteredEducationEnums = data.Enum_EducationLevel.filter(
		(ele) => ele.educationLevel !== 'NOFORMALEDUCATION'
	)

	return (
		<>
			<Card>
				<Card.Body className={styles.profileCard}>
					<Row className="w-100 align-items-center">
						<Col>
							<h1 className={styles.profileHeader}>
								{isNewProfile === true
									? t('update_profile.create')
									: t('update_profile.update')}{' '}
								{t('update_profile.my_profile')}
							</h1>
						</Col>
						<Col md={4}>
							<Button
								className={`text ${styles.singpass}`}
								variant="outline"
								type="button"
								href={`/api/singpass-auth/myinfo-login?type=${isNewProfile?'register':'update'}`}
							>
								<strong>Retrieve Myinfo with{' '}</strong>
								<Image
									src="https://portal.singpass.gov.sg/home/ui/static/media/singpass-logo.bdceeae10dd5834331ee450d84f50e8f.svg"
									height={16}
									alt="Retrieve Myinfo with sing pass"
									className='mt-1'
								/>
							</Button>
						</Col>
					</Row>
					<ListGroup horizontal="sm" className={styles.headerList}>
						<ListGroup.Item
							variant={currentStep === 1 ? 'success' : ''}
							className={styles.headerItem}
							onClick={() => (isNewProfile ? null : setCurrentStep(1))}
						>
							{t('update_profile.personal_details')}
						</ListGroup.Item>
						<ListGroup.Item
							variant={currentStep === 2 ? 'success' : ''}
							className={styles.headerItem}
							onClick={() => (isNewProfile ? null : setCurrentStep(2))}
						>
							{t('update_profile.work_experience')}
						</ListGroup.Item>
						<ListGroup.Item
							variant={currentStep === 3 ? 'success' : ''}
							className={styles.headerItem}
							onClick={() => (isNewProfile ? null : setCurrentStep(3))}
						>
							{t('update_profile.education')}
						</ListGroup.Item>
						<ListGroup.Item
							variant={currentStep === 4 ? 'success' : ''}
							className={styles.headerItem}
							onClick={() => (isNewProfile ? null : setCurrentStep(4))}
						>
							{t('update_profile.availability')}
						</ListGroup.Item>
					</ListGroup>

					{currentStep === 1 && (
						<PersonalDetails
							setCurrentStep={setCurrentStep}
							inputs={inputs}
							setInputs={setInputs}
							datas={data}
							boolean={boolean}
							setBoolean={setBoolean}
							imgPreview={imgPreview}
							setImgPreview={setImgPreview}
							setImgData={setImgData}
							isMyinfoSuccess={isMyinfoSuccess}
						/>
					)}
					{currentStep === 2 && (
						<WorkExperience
							setCurrentStep={setCurrentStep}
							experiences={experiences}
							setExperiences={setExperiences}
							datas={data}
							experienceIds={experienceIds}
							setExperienceIds={setExperienceIds}
							inputs={inputs}
							setInputs={setInputs}
							// cvData={cvData}
							setCVData={setCVData}
						/>
					)}
					{currentStep === 3 && (
						<Education
							setCurrentStep={setCurrentStep}
							educationEnums={filteredEducationEnums}
							educations={educations}
							setEducations={setEducations}
							educationIds={educationIds}
							setEducationIds={setEducationIds}
						/>
					)}
					{currentStep === 4 && (
						<AvailabilityStatus
							setCurrentStep={setCurrentStep}
							inputs={inputs}
							setInputs={setInputs}
							confirmPw={confirmPw}
							setConfirmPw={setConfirmPw}
							experiences={experiences}
							educations={educations}
							boolean={boolean}
							setBoolean={setBoolean}
							imgData={imgData}
							cvData={cvData}
							experienceIds={experienceIds}
							educationIds={educationIds}
						/>
					)}
				</Card.Body>
			</Card>
			<Modal
				show={isMyinfoFail}
				size="lg"
				onHide={() => setIsMyinfoFail(false)}
				centered
			>
				<Modal.Header closeButton className="border-0" />
				<Modal.Body className="text-center p-5 pt-0">
					<FontAwesomeIcon icon={faCircleInfo} className={styles.iconInfo} />
					<div className="mb-4">
						<strong className={styles.textBold}>
							{t('register.singpass_myinfo_fail')}
						</strong>
					</div>
					<Button
						className="text-white"
						variant="primary"
						type="button"
						size="lg"
						onClick={() => setIsMyinfoFail(false)}
					>
						{t('register.input_manual')}
					</Button>
				</Modal.Body>
			</Modal>
		</>
	)
}
